import { useAdvanceSearchContext } from "../AdvanceSearchContext";

export default function OtherSkills() {
  const { searchObject, onChange, t } = useAdvanceSearchContext();
  
  return (
    <fieldset>
      <legend>{t("Other Skills")}</legend>
      <input
        name="otherSkills"
        onChange={onChange}
        value={searchObject.otherSkills || ""}
        className="form-control"
      />
    </fieldset>
  );
}
